




































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import BerkasFormPanel from "@/components/pemeriksaan/berkasRm/BerkasFormPanel.vue";
import DialogUploadBerkas from "@/components/pemeriksaan/berkasRm/DialogUploadBerkas.vue";
import AjukanAksesRevisiDialog from "@/components/pemeriksaan/AjukanAksesRevisiDialog.vue";
import storeICT from "@/store/modules/InformedConsentTindakanStore";
import ICTService from "@/services/informedConsentTindakanService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { getHumanDateTime } from "@/utility/DateUtils";

@Component({
  components: { BerkasFormPanel, DialogUploadBerkas, AjukanAksesRevisiDialog },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardInformedConsentTindakan extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get rmKey(): string {
    const v = String(this.rm || "");
    return v.length > 6 ? v.slice(-6) : v;
  }

  dialogForm = false;
  isEditing = false;
  formValid = false;
  saving = false;
  finalizingId: number | null = null;
  selectedItem: any = null;
  terhadapDiriSendiri = true;
  viewOnly = false;
  private hydratingForm = false;
  private pemberiInfoAuto = "";

  uploadOpen = false;
  uploadTarget: any = null;

  form: any = this.getEmptyForm();
  formFase2: any = this.getEmptyFormFase2();

  prognosisOptions = ["Baik", "Jelek", "Tidak dapat diperkirakan"];

  jenisFormOptions = [
    { text: "Umum (Form A)", value: "umum" },
    { text: "Kuretase (Form B)", value: "kuretase" },
    { text: "Ginekologi (Form C)", value: "ginekologi" },
    { text: "Persalinan (Form D)", value: "persalinan" },
    { text: "Sectio Caesarea (Form E)", value: "sc" },
    { text: "Laparotomi (Form F)", value: "laparotomi" }
  ];

  hubunganOptions = [
    { text: "Pasien Sendiri", value: "diri_sendiri" },
    { text: "Suami", value: "suami" },
    { text: "Istri", value: "istri" },
    { text: "Anak", value: "anak" },
    { text: "Orang Tua", value: "orang_tua" },
    { text: "Kakak/Adik", value: "kakak_adik" },
    { text: "Wali Sah", value: "wali" }
  ];

  headers = [
    { text: "No", value: "no", sortable: false, width: 50 },
    { text: "Jenis Form", value: "jenis_form", width: 160 },
    { text: "Tindakan", value: "tindakan" },
    { text: "Keputusan", value: "keputusan", width: 100 },
    { text: "Status", value: "status", sortable: false, width: 150 },
    { text: "Aksi", value: "aksi", sortable: false, width: 230 }
  ];

  mounted() {
    storeICT.getByRegister(this.register);
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
  }

  get loading() { return storeICT.loading; }
  get items() { return storeICT.items; }
  get dokterList() { return storeDokter.listAll; }
  get currentUserId() { return userModule.user?.id; }

  // ============ HELPERS ============

  getEmptyForm() {
    return {
      pemberi_info_nama: "",
      penerima_info_nama: "",
      jenis_form: "",
      dr_pelaksana_id: RegisterKunjungan.register?.dokter?.id || null,
      informasi_items: this.getEmptyTemplate()
    };
  }

  getEmptyFormFase2() {
    return {
      keputusan: "",
      penyatakan_nama: "",
      penyatakan_umur: null,
      penyatakan_jk: null,
      penyatakan_alamat: "",
      penyatakan_hubungan: "",
      target_nama: "",
      target_umur: null,
      target_jk: null,
      target_alamat: "",
      nama_tindakan: "",
      tempat_consent: "Bantul",
      tgl_consent: localISODate(),
      jam_consent: new Date().toTimeString().substr(0, 5),
      saksi_pasien_nama: "",
      saksi_rs_nama: ""
    };
  }

  getEmptyTemplate() {
    return [
      { no: 1, label: "Diagnosis (WD & DD)", isi_informasi: "", paraf: false },
      { no: 2, label: "Dasar Diagnosis", isi_informasi: "", paraf: false },
      { no: 3, label: "Tindakan Kedokteran", isi_informasi: "", paraf: false },
      { no: 4, label: "Indikasi Tindakan", isi_informasi: "", paraf: false },
      { no: 5, label: "Tata Cara", isi_informasi: "", paraf: false },
      { no: 6, label: "Tujuan", isi_informasi: "", paraf: false },
      { no: 7, label: "Risiko", isi_informasi: "", paraf: false },
      { no: 8, label: "Komplikasi", isi_informasi: "", paraf: false },
      { no: 9, label: "Prognosis", isi_informasi: "", paraf: false },
      { no: 10, label: "Alternatif & Risiko", isi_informasi: "", paraf: false },
      { no: 11, label: "Lain-lain", isi_informasi: "", paraf: false }
    ];
  }

  formatTanggal(val: string) {
    return getHumanDateTime(val);
  }

  subKodeBerkas(item: { jenis_form?: string } | null): string {
    return item && item.jenis_form ? `informed_consent_${item.jenis_form}` : "";
  }

  judulBerkas(item: { jenis_form?: string } | null): string {
    const jenis =
      item && item.jenis_form ? this.formatJenisForm(item.jenis_form) : "";
    return jenis
      ? `Berkas Informed Consent — ${jenis} (hasil scan TTD basah)`
      : "Berkas Informed Consent (hasil scan TTD basah)";
  }

  formatJenisForm(val: string) {
    const map: Record<string, string> = {
      umum: "Umum (A)",
      kuretase: "Kuretase (B)",
      ginekologi: "Ginekologi (C)",
      persalinan: "Persalinan (D)",
      sc: "Sectio Caesarea (E)",
      laparotomi: "Laparotomi (F)"
    };
    return map[val] || val;
  }

  formatHubungan(val: string) {
    const map: Record<string, string> = {
      diri_sendiri: "Diri Sendiri",
      suami: "Suami",
      istri: "Istri",
      anak: "Anak",
      orang_tua: "Orang Tua",
      kakak_adik: "Kakak/Adik",
      wali: "Wali Sah"
    };
    return map[val] || val;
  }

  getTindakanFromItems(item: any) {
    if (item.informasi_items && item.informasi_items[2]) {
      return item.informasi_items[2].isi_informasi || "-";
    }
    return "-";
  }

  unlockedByRevision(item: any): boolean {
    return !!(item && !item.is_finalized && item.revision_request_id);
  }

  cardReadOnly(item: any): boolean {
    return this.readOnly && !this.unlockedByRevision(item);
  }

  isCreator(item: any): boolean {
    return !!item && item.creator_user_id == this.currentUserId;
  }

  getStatusColor(item: any) {
    if (item.is_finalized) return "green";
    if (this.unlockedByRevision(item)) return "amber darken-2";
    return "orange";
  }

  getStatusLabel(item: any) {
    if (item.is_finalized) {
      return item.keputusan === "setuju" ? "Final · Setuju" : item.keputusan === "tolak" ? "Final · Tolak" : "Final";
    }
    if (this.unlockedByRevision(item)) return "Dibuka untuk revisi";
    return "Draft";
  }

  canEditItemState(item: any) {
    if (this.cardReadOnly(item)) return false;
    if (item.is_finalized) return false;
    return this.isCreator(item);
  }

  canDeleteItemState(item: any) {
    return this.canEditItemState(item);
  }

  canFinalize(item: any) {
    if (!item || item.is_finalized) return false;
    if (this.cardReadOnly(item)) return false;
    return this.isCreator(item);
  }

  refreshList() {
    storeICT.getByRegister(this.register);
  }

  dokterNama(id: number | null): string {
    if (!id) return "";
    const d = this.dokterList.find((x: any) => x.id == id);
    return d ? d.nama || "" : "";
  }

  // ============ JENIS FORM CHANGE → TEMPLATE ============

  @Watch("form.jenis_form")
  async onJenisFormChange(val: string, oldVal: string) {
    if (this.hydratingForm) return;
    if (!val) return;
    if (oldVal && this.form.informasi_items.some((i: any) => i.isi_informasi)) {
      if (!confirm("Ganti jenis form akan mereset isi informasi ke template. Lanjutkan?")) {
        this.hydratingForm = true;
        this.$nextTick(() => {
          this.form.jenis_form = oldVal;
          this.$nextTick(() => { this.hydratingForm = false; });
        });
        return;
      }
    }
    try {
      const resp = await ICTService.getTemplate(val);
      if (resp.data?.data) {
        this.form.informasi_items = resp.data.data;
      }
    } catch {
      this.form.informasi_items = this.getEmptyTemplate();
    }
  }

  @Watch("form.dr_pelaksana_id")
  onDokterChange(val: number | null) {
    if (this.hydratingForm) return;
    const nama = this.dokterNama(val);
    if (!this.form.pemberi_info_nama || this.form.pemberi_info_nama === this.pemberiInfoAuto) {
      this.form.pemberi_info_nama = nama;
    }
    this.pemberiInfoAuto = nama;
  }

  // ============ CREATE/EDIT ============

  openCreate() {
    this.hydratingForm = true;
    this.viewOnly = false;
    this.form = this.getEmptyForm();
    this.formFase2 = this.getEmptyFormFase2();
    this.selectedItem = null;
    this.isEditing = false;
    this.terhadapDiriSendiri = true;
    this.pemberiInfoAuto = this.dokterNama(this.form.dr_pelaksana_id);
    this.form.pemberi_info_nama = this.pemberiInfoAuto;
    this.autoFillPasienData();
    this.dialogForm = true;
    this.$nextTick(() => { this.hydratingForm = false; });
  }

  openView(item: any) {
    this.openEdit(item, true);
  }

  openEdit(item: any, viewOnly = false) {
    this.hydratingForm = true;
    this.viewOnly = viewOnly;
    this.form = {
      jenis_form: item.jenis_form,
      dr_pelaksana_id: item.dr_pelaksana_id,
      pemberi_info_nama: item.pemberi_info_nama || this.dokterNama(item.dr_pelaksana_id),
      penerima_info_nama: item.penerima_info_nama || "",
      informasi_items: JSON.parse(JSON.stringify(item.informasi_items))
    };
    this.pemberiInfoAuto = this.dokterNama(item.dr_pelaksana_id);
    this.selectedItem = item;
    this.isEditing = true;
    this.hydrateFormPersetujuan(item);
    this.dialogForm = true;
    this.$nextTick(() => { this.hydratingForm = false; });
  }

  async simpan() {
    this.saving = true;
    try {
      const payload = {
        register_id: this.register,
        pasien_rm: this.rm,
        ...this.form,
        ...this.formFase2
      };

      let resp;
      if (this.isEditing && this.selectedItem) {
        resp = await ICTService.update(this.selectedItem.id, payload);
      } else {
        resp = await ICTService.create(payload);
      }

      if (resp.data.status == "1" || resp.data.status == 1) {
        appModule.NoticeDelay("Informed Consent berhasil disimpan. Silakan cetak untuk ditandatangani basah.");
        this.selectedItem = resp.data.data;
        this.isEditing = true;
        this.refreshList();
      }
    } finally {
      this.saving = false;
    }
  }

  async finalisasi(item: any) {
    if (!item || this.finalizingId) return;
    if (!confirm("Finalisasi Informed Consent ini? Setelah difinalisasi dokumen terkunci dan hanya dapat diubah lewat pengajuan revisi.")) return;

    this.finalizingId = item.id;
    try {
      const resp = await ICTService.finalize(item.id);
      if (resp.data?.status == 1 || resp.data?.status == "1") {
        appModule.NoticeDelay(resp.data.message || "Informed Consent difinalisasi");
        if (this.selectedItem && this.selectedItem.id == item.id) {
          this.selectedItem = resp.data.data;
          this.viewOnly = true;
        }
        this.refreshList();
      }
    } finally {
      this.finalizingId = null;
    }
  }

  // ============ BERKAS SCAN ============

  openUpload(item: any) {
    if (!item || this.cardReadOnly(item)) return;
    this.uploadTarget = item;
    this.uploadOpen = true;
  }

  async onUploaded() {
    if (this.selectedItem && this.uploadTarget && this.selectedItem.id == this.uploadTarget.id) {
      await this.reloadSelectedItem();
    }
    this.refreshList();
  }

  async onBerkasChanged() {
    await this.reloadSelectedItem();
    this.refreshList();
  }

  // ============ BAGIAN PERSETUJUAN / PENOLAKAN ============

  hydrateFormPersetujuan(item: any) {
    this.formFase2 = {
      keputusan: item.keputusan || "",
      penyatakan_nama: item.penyatakan_nama || "",
      penyatakan_umur: item.penyatakan_umur,
      penyatakan_jk: item.penyatakan_jk,
      penyatakan_alamat: item.penyatakan_alamat || "",
      penyatakan_hubungan: item.penyatakan_hubungan || "",
      target_nama: item.target_nama || "",
      target_umur: item.target_umur,
      target_jk: item.target_jk,
      target_alamat: item.target_alamat || "",
      nama_tindakan: item.nama_tindakan || this.getTindakanFromItems(item),
      tempat_consent: item.tempat_consent || "Bantul",
      tgl_consent: item.tgl_consent || localISODate(),
      jam_consent: item.jam_consent || new Date().toTimeString().substr(0, 5),
      saksi_pasien_nama: item.saksi_pasien_nama || "",
      saksi_rs_nama: item.saksi_rs_nama || ""
    };
    this.terhadapDiriSendiri =
      !item.penyatakan_hubungan || item.penyatakan_hubungan === "diri_sendiri";

    // Auto-fill saat pertama kali buka (belum ada data tersimpan)
    if (!item.penyatakan_nama) {
      this.autoFillPasienData();
    }
  }

  autoFillPasienData() {
    const p = storePasien.identitasPasien;
    if (!p) return;
    const jk = p.jk === "Laki-laki" ? "L" : p.jk === "Perempuan" ? "P" : p.jk;
    let umur: number | null = null;
    if (p.tgl_lahir) {
      const birth = new Date(p.tgl_lahir);
      const now = new Date();
      umur = Math.floor((now.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
    }

    // Default: diri sendiri → penyatakan = data pasien
    this.formFase2.penyatakan_nama = p.nama || "";
    this.formFase2.penyatakan_jk = jk;
    this.formFase2.penyatakan_alamat = p.alamat || "";
    this.formFase2.penyatakan_umur = umur;
    this.formFase2.penyatakan_hubungan = "diri_sendiri";
    this.terhadapDiriSendiri = true;
  }

  onTerhadapChange(val: boolean) {
    const p = storePasien.identitasPasien;
    const jk = p ? (p.jk === "Laki-laki" ? "L" : p.jk === "Perempuan" ? "P" : p.jk) : null;
    let umur: number | null = null;
    if (p && p.tgl_lahir) {
      const birth = new Date(p.tgl_lahir);
      const now = new Date();
      umur = Math.floor((now.getTime() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
    }

    if (val) {
      // Diri sendiri: penyatakan = pasien, clear target
      this.formFase2.penyatakan_hubungan = "diri_sendiri";
      this.formFase2.target_nama = "";
      this.formFase2.target_umur = null;
      this.formFase2.target_jk = null;
      this.formFase2.target_alamat = "";
      if (p) {
        this.formFase2.penyatakan_nama = p.nama || "";
        this.formFase2.penyatakan_jk = jk;
        this.formFase2.penyatakan_alamat = p.alamat || "";
        this.formFase2.penyatakan_umur = umur;
      }
    } else {
      // Orang lain: target = pasien, clear penyatakan
      this.formFase2.penyatakan_hubungan = "";
      this.formFase2.penyatakan_nama = "";
      this.formFase2.penyatakan_umur = null;
      this.formFase2.penyatakan_jk = null;
      this.formFase2.penyatakan_alamat = "";
      if (p) {
        this.formFase2.target_nama = p.nama || "";
        this.formFase2.target_jk = jk;
        this.formFase2.target_alamat = p.alamat || "";
        this.formFase2.target_umur = umur;
      }
    }
  }

  // ============ RELOAD HELPERS ============

  async reloadSelectedItem() {
    if (!this.selectedItem) return;
    const resp = await ICTService.find(this.selectedItem.id);
    if (resp.data?.data) {
      this.selectedItem = resp.data.data;
    }
  }

  // ============ PDF & DELETE ============

  cetakPdf(item: any) {
    ICTService.print(item.id);
  }

  async hapus(item: any) {
    if (!confirm("Yakin ingin menghapus informed consent ini?")) return;
    const resp = await ICTService.destroy(item.id);
    if (resp.data?.status == 1 || resp.data?.status == "1") {
      appModule.NoticeDelay("Berhasil menghapus data");
      this.refreshList();
    }
  }
}
